<template>

    <div class="row">
        <div :class="{'col-sm-6':true, 'col-sm-offset-3':allimages === null}">
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">Mijn nieuwe afbeeldingen</h2>
                    <div class="box-tools">
                        <router-link
                            class="btn btn-primary btn-xs"
                            :to="{name:'images.add.index'}"
                            v-tooltip.bottom="'Afbeelding toevoegen'"
                        >
                            <i class="mdi mdi-plus"></i>
                            <span class="sr-only">Afbeelding toevoegen</span>
                        </router-link>
                    </div>
                </div>
                <div class="box-body no-padding">
                    <table class="table table-striped table-hover">
                        <thead>
                            <tr>
                                <th>Thumb</th>
                                <th>Toegevoegd op</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="userimages.length === 0">
                                <td colspan="3">Er zijn geen afbeeldingen gevonden</td>
                            </tr>
                            <tr v-for="image in userimages">
                                <td>
                                    <img :src="image.url" alt="" style="max-width:100px;max-height:100px;" />
                                </td>
                                <td>
                                    {{ image.created_at }}
                                </td>
                                <td>
                                    <button class="btn btn-default btn-sm pull-right" @click="openPendingImage(image)">
                                        <i class="mdi mdi-eye"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="overlay" v-if="loading">
                    <i class="fa fa-refresh fa-spin"></i>
                </div>
            </div>
        </div>
        <div class="col-sm-6"
            v-if="allimages !== null"
        >
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">Nieuwe afbeeldingen van anderen</h2>
                </div>
                <div class="box-body no-padding">
                    <table class="table table-striped table-hover">
                        <thead>
                            <tr>
                                <th>Thumb</th>
                                <th>Toegevoegd door</th>
                                <th>Toegevoegd op</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="allimages.length === 0">
                                <td colspan="4">Er zijn geen afbeeldingen gevonden</td>
                            </tr>
                            <tr v-for="image in allimages">
                                <td>
                                    <img :src="image.url" alt="" style="max-width:100px;max-height:100px;" />
                                </td>
                                <td>{{ image.creator }}</td>
                                <td>{{ image.created_at }}</td>
                                <td>
                                    <button class="btn btn-default btn-sm pull-right" @click="openPendingImage(image)">
                                        <i class="mdi mdi-eye"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <pending-image-modal
            ref="pendingImageModal"
            :imagespecs="imagespecs"
            :projects="projects"
            @pending-image-is-being-processed="removeImageAsPending"
        ></pending-image-modal>
    </div>

</template>

<script>

    import { mapGetters, mapActions } from 'vuex';
    import axios from 'axios';
    import PendingImageModal from "./PendingImageModal";

    export default {

        components: {
            PendingImageModal,
        },

        data() {
            return {
                allimages: null,
                imagespecs: {
                    categories:[],
                    materials:[],
                    sizes:[],
                    statuses:[],
                    types:[],
                },
                loading:true,
                projects:[],
                userimages: [],
            }
        },

        methods: {

            ...mapActions([
                "parseData",
            ]),

            getImages() {
                axios.get(this.route('api.v1.images.pending'))
                .then(resp => {
                    if (resp.data.data.all) {
                        this.allimages = resp.data.data.all;
                    }
                    this.userimages = resp.data.data.user;
                    this.imagespecs = resp.data.data.imagespecs;
                    this.loading = false;
                })
            },

            getProjects() {
                axios.get(this.route('api.v1.projects.index'), {params:{withtasks:true}})
                .then(resp => this.projects = resp.data.data);
            },

            openPendingImage(image) {
                this.$refs.pendingImageModal.show(image);
            },

            removeImageAsPending(imageid) {
                if (this.allimages !== null) {
                    this.allimages.splice(this.allimages.findIndex(img => img.uuid === imageid), 1);
                }
                this.userimages.splice(this.userimages.findIndex(img => img.uuid === imageid), 1);
            },

            updateImages() {
                this.loading = true;
                this.getImages();
            },
        },

        mounted(){
            this.parseData();
            this.getImages();
            this.getProjects();
        },

        name:'ImagesPending',

    }

</script>
